import React from 'react';
import { Helmet } from 'react-helmet';
import { SITE_URL, pages, notFound } from './pages';

export default function SEO({ path }) {
  const page = pages[path] || notFound;
  const url = SITE_URL + (path === '/' ? '/' : path);
  const organization = {
    '@type': 'Organization', '@id': `${SITE_URL}/#organization`,
    name: 'Surya Group', url: `${SITE_URL}/`, logo: `${SITE_URL}/social-logo.png`,
    sameAs: [
      'https://www.linkedin.com/company/suryagroupestimation',
      'https://www.instagram.com/suryagroup.us/',
      'https://www.facebook.com/people/Surya-Group-Estimation/61574719572294/',
    ],
  };
  const graph = [organization, {
    '@type': 'WebSite', '@id': `${SITE_URL}/#website`, name: 'Surya Group',
    url: `${SITE_URL}/`, publisher: { '@id': organization['@id'] },
  }, {
    '@type': path === '/about' ? 'AboutPage' : path === '/contact-us' ? 'ContactPage' : path === '/blog' ? 'CollectionPage' : 'WebPage',
    '@id': `${url}#webpage`, url, name: page.title, description: page.description,
    isPartOf: { '@id': `${SITE_URL}/#website` },
  }];
  if (page.service) {
    graph.push({ '@type': 'Service', '@id': `${url}#service`, name: page.service,
      description: page.description, url, provider: { '@id': organization['@id'] } });
    graph.push({ '@type': 'BreadcrumbList', itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Home', item: `${SITE_URL}/` },
      { '@type': 'ListItem', position: 2, name: page.service, item: url },
    ] });
  }
  return (
    <Helmet>
      <title>{page.title}</title>
      <meta name="description" content={page.description} />
      <meta name="robots" content={page.noindex ? 'noindex, follow' : 'index, follow, max-image-preview:large'} />
      {!page.noindex && <link rel="canonical" href={url} />}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Surya Group" />
      <meta property="og:locale" content="en_US" />
      <meta property="og:title" content={page.title} />
      <meta property="og:description" content={page.description} />
      <meta property="og:url" content={pages[path] ? url : `${SITE_URL}/404.html`} />
      <meta property="og:image" content={`${SITE_URL}/social-logo.png`} />
      <meta property="og:image:width" content="527" />
      <meta property="og:image:height" content="504" />
      <meta property="og:image:alt" content="Surya Group logo" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={page.title} />
      <meta name="twitter:description" content={page.description} />
      <meta name="twitter:image" content={`${SITE_URL}/social-logo.png`} />
      <meta name="twitter:image:alt" content="Surya Group logo" />
      {!page.noindex && <script type="application/ld+json">{JSON.stringify({ '@context': 'https://schema.org', '@graph': graph }).replace(/</g, '\\u003c')}</script>}
    </Helmet>
  );
}
